"use client"

import React from "react";
import {useCryptoNavActions} from "@/lib/useCryptoNavActions/useCryptoNavActions";

const CryptoNavTrigger = () => {
    const {toggleCryptNav} = useCryptoNavActions()
    return <button
        onClick={toggleCryptNav}
        className={`rotate-0  fixed z-50 -top-7 h-[30px] translate-y-9 crypto-nav-trigger right-0 cursor-pointer bg-black  px-1 rounded-b-md transition-all duration-300`}>
        <svg
            className={`transition-all duration-300`}
            xmlns="http://www.w3.org/2000/svg"
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M18.2929 15.2893C18.6834 14.8988 18.6834 14.2656 18.2929 13.8751L13.4007 8.98766C12.6195 8.20726 11.3537 8.20757 10.5729 8.98835L5.68257 13.8787C5.29205 14.2692 5.29205 14.9024 5.68257 15.2929C6.0731 15.6835 6.70626 15.6835 7.09679 15.2929L11.2824 11.1073C11.673 10.7168 12.3061 10.7168 12.6966 11.1073L16.8787 15.2893C17.2692 15.6798 17.9024 15.6798 18.2929 15.2893Z"
                fill="#ffffff"
            />
        </svg>
        <div className="-translate-y-[100%] hidden"/>

        <span className="absolate opacity-0 text-[0.0000001px] "> show prices</span>
    </button>
}
export default CryptoNavTrigger